"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateTimeIs = exports.dateTimeIs = void 0;
const get_1 = __importDefault(require("lodash/get"));
const isNil_1 = __importDefault(require("lodash/isNil"));
const merge_1 = __importDefault(require("lodash/merge"));
const DateUtils_1 = require("../../native/DateUtils");
const Exists_1 = require("../common/Exists");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
// eslint-disable-next-line sonarjs/cognitive-complexity
async function dateTimeIs(value, args, constraints) {
    var _a, _b, _c, _d;
    constraints = (0, merge_1.default)({}, constraints);
    const existsResults = await (0, Exists_1.exists)(value, args, constraints);
    if (existsResults.pass === false || existsResults.skipped) {
        return existsResults;
    }
    const { comparator } = constraints;
    const compareValue = (_a = constraints.compareValue) !== null && _a !== void 0 ? _a : (0, get_1.default)(args === null || args === void 0 ? void 0 : args.object, constraints.compareProperty);
    const dateTime = DateUtils_1.DateUtils.toZonedDateTime(value, constraints.valueZone);
    if ((0, isNil_1.default)(dateTime)) {
        return { pass: false, message: `should be a valid date time` };
    }
    const constraintDateTime = DateUtils_1.DateUtils.toZonedDateTime(compareValue, constraints.compareValueZone);
    if ((0, isNil_1.default)(constraintDateTime)) {
        return { pass: false, message: `constraint value should be a valid date time` };
    }
    const compareResult = dateTime.compareTo(constraintDateTime);
    if (compareResult === 0) {
        if (comparator !== DateTimeIs.Comparator.EQUALS &&
            comparator !== DateTimeIs.Comparator.EQUALS_OR_AFTER &&
            comparator !== DateTimeIs.Comparator.EQUALS_OR_BEFORE) {
            return {
                pass: false,
                message: `should be ${comparator} ${(_b = constraints.compareValue) !== null && _b !== void 0 ? _b : constraints.compareProperty}`,
            };
        }
    }
    else if (compareResult < 0) {
        if (comparator !== DateTimeIs.Comparator.BEFORE && comparator !== DateTimeIs.Comparator.EQUALS_OR_BEFORE) {
            return {
                pass: false,
                message: `should be ${comparator} ${(_c = constraints.compareValue) !== null && _c !== void 0 ? _c : constraints.compareProperty}`,
            };
        }
    }
    else {
        if (comparator !== DateTimeIs.Comparator.AFTER && comparator !== DateTimeIs.Comparator.EQUALS_OR_AFTER) {
            return {
                pass: false,
                message: `should be ${comparator} ${(_d = constraints.compareValue) !== null && _d !== void 0 ? _d : constraints.compareProperty}`,
            };
        }
    }
    return { pass: true };
}
exports.dateTimeIs = dateTimeIs;
/**
 * Compares against another date time value
 * Must have either compareDateTime or compareProperty (compareDateTime takes precedence)
 * `valueZone` and `compareZone` are only applicable if the values do not have a specified zone, defaults to SG zone
 * Uses `DateUtils.toZonedDateTime` under the hood
 */
function DateTimeIs(constraints, options) {
    var _a;
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "DateTimeIs",
        defaultMessage: `should be ${constraints.comparator} ${(_a = constraints.compareValue) !== null && _a !== void 0 ? _a : constraints.compareProperty}`,
        options,
        constraints,
        validateFn: dateTimeIs,
    });
}
exports.DateTimeIs = DateTimeIs;
(function (DateTimeIs) {
    let Comparator;
    (function (Comparator) {
        Comparator["AFTER"] = "after";
        Comparator["BEFORE"] = "before";
        Comparator["EQUALS"] = "equals to";
        Comparator["EQUALS_OR_AFTER"] = "equals to or after";
        Comparator["EQUALS_OR_BEFORE"] = "equals to or before";
    })(Comparator = DateTimeIs.Comparator || (DateTimeIs.Comparator = {}));
})(DateTimeIs || (exports.DateTimeIs = DateTimeIs = {}));
//# sourceMappingURL=DateTimeIs.js.map